import { Media } from 'media'
import { ComponentType } from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { TextHeroDesktop } from './TextHeroDesktop'
import { TextHeroMobile } from './TextHeroMobile'

const Wrapper = styled.div`
  display: none;
  padding: 0 20px;

  ${up('sm')} {
    display: block;
  }
`

export const TextHero: ComponentType<{ title?: string, subtitle?: string }> = ({ title, subtitle }) => (
  <Wrapper>
    <Media at="xs">
      <TextHeroMobile title={title} subtitle={subtitle} />
    </Media>
    <Media greaterThan="xs">
      <TextHeroDesktop title={title} subtitle={subtitle} />
    </Media>
  </Wrapper>
)